/** Layout tokens for the KYD custom audience dialog. */
export const KYD_AUDIENCE_DIALOG_STYLES = {
  fontFamily: `'Work Sans', sans-serif`,
  shellBg: "#fafafa",
  shellBorder: "1px solid #ddd",
  shellRadius: "16px",
  shellGapPx: 24,
  titleColor: "#1a202c",
  titleFontSize: "20px",
  titleFontWeight: 600,
  titleLineHeight: 1.4,
  subtitleColor: "rgba(26, 32, 44, 0.6)",
  subtitleFontSize: "14px",
  subtitleFontWeight: 500,
  subtitleLineHeight: 1.4,
  sectionLabelColor: "#1a202c",
  sectionLabelFontSize: "16px",
  sectionLabelFontWeight: 500,
  panelBg: "white",
  panelBorder: "1px solid rgba(0, 0, 0, 0.1)",
  panelRadius: "8px",
  panelPadding: "25px",
  panelGapPx: 12,
  filtersPanelGapPx: 24,
  disabledHintColor: "#4a5568",
  disabledHintFontSize: "15px",
  fieldShadow: "0px 10px 15px -5px #f7f7f7",
  fieldBorder: "1px solid #e6e6e6",
  orLabelColor: "#718096",
  segmentClearBg: "#aaa",
} as const;
